export default __webpack_public_path__ + "static/media/mapview.4b97193a.png";